import {Component, Input, OnInit} from '@angular/core';
import {ToolService} from '@app/core/services/tool.service';
import {TableConfig} from '@app/shared/util/table-config.utils';
import {Tool} from '@app/tool/model/tool.model';
import {ToolSet} from '@app/tool/model/toolSet.model';
import {Log} from 'ng2-logger';

@Component({
    selector: 'app-maintenance-plan-tools-form',
    templateUrl: './maintenance-plan-tools-form.component.html',
    styleUrls: ['./maintenance-plan-tools-form.component.scss']
})
export class MaintenancePlanToolsFormComponent implements OnInit {
    _logger = Log.create(MaintenancePlanToolsFormComponent.name);

    @Input() showErrors = false;
    @Input() isEditMode = false;
    @Input() maintenancePlanId = null;

    public tools: (Tool | ToolSet)[] = [];
    public selectedTools: (Tool | ToolSet)[] = [];
    public unselectedTools: (Tool | ToolSet)[] = [];
    public displayOnlySelected = false;

    public loading = false;

    toolConfig = new TableConfig();
    selectedToolsConfig = new TableConfig();

    get valid() {
        return this.selectedTools.length > 0;
    }

    get value() {
        return this.selectedTools;
    }

    constructor(private toolService: ToolService) {
    }

    ngOnInit() {
        this.tools = [];
        this.selectedTools = [];
        this.unselectedTools = [];
    }

    public init(tools = null) {
        this.getTools(this.toolConfig);
        if (this.isEditMode && tools) {
            this.setSelectedTools(tools);
        }
    }

    public getFormValue() {
        return {tools: this.selectedTools};
    }

    public reset() {
        this.tools = [];
        this.selectedTools = [];
        this.unselectedTools = [];
    }

    private getTools(config: TableConfig) {
        this._logger.info('getTools:: Retrieving list of tools');

        this.tools = [];
        this.loading = true;

        config.upsertFilter('includeWithoutMaintenancePlan', true);
        if (this.maintenancePlanId) {
            config.upsertFilter('maintenancePlanIds', [this.maintenancePlanId]);
        }

        this.toolService.getTools(config, false, false).subscribe({
            next: (tools: any) => {
                this.loading = false;
                this._logger.info('getTools:: API returned data ', tools);
                this.tools = tools.tools;
                this.toolConfig.pager.count = tools.count;
            },
            error: () => {
                this.loading = false;
            }
        });
    }

    setSelectedTools(tools: any[]) {
        this.selectedTools = tools;
    }

    onToolsPageChange(tableState) {
        this.getTools(tableState);
    }

    onToolsSortChange(tableState) {
        this.getTools(tableState);
    }

    onToolsFilterChange(tableState) {
        this.getTools(tableState);
    }

    onToolsGroupChange(tableState) {
        this.getTools(tableState);
    }

    onToolClicked(toolDetails: { checked: boolean, group: Tool | ToolSet }) {
        if (toolDetails.checked) {
            // add to selected
            this.selectedTools.push(toolDetails.group);

            // remove from unselected
            const index = this.unselectedTools.findIndex(item => item.id === toolDetails.group.id);
            if (index > -1) {
                this.unselectedTools.splice(index, 1);
            }
        } else {
            // add to unselected
            this.unselectedTools.push(toolDetails.group);

            // remove from selected
            const index = this.selectedTools.findIndex(item => item.id === toolDetails.group.id);
            if (index > -1) {
                this.selectedTools.splice(index, 1);
            }
        }
        this.selectedToolsConfig.pager.count = this.selectedTools.length;
    }

    onChangeView() {
        this.displayOnlySelected = !this.displayOnlySelected;
    }
}
